import { FC, useState } from 'react'
import { Table, Toolbar, BreadcrumHeader } from 'shared'
import { useParams } from 'react-router'
import { BreadcrumbItemType } from 'shared/molecules/Breadcrum/Breadcrum'
import { useGetClientEmailQuery } from '../clientApiSlice'
import '../client.scss'
import CreateEditEmail from '../clientEmail/CreateEditEmail/CreateEditEmail'
import { EmailConfig } from './types'

const { Column, HeaderCell, Cell, ActionCell, DateTimeCell } = Table

const ClientEmailList: FC = () => {
  const [selectedEmail, setSelectedEmail] = useState<EmailConfig | null>(null)
  const [addEmailModal, setAddEmailModal] = useState(false)
  const [isEditMode, setIsEditMode] = useState<boolean>(false)

  const { id } = useParams()
  const { data: EmailData, isLoading } = useGetClientEmailQuery({ id: id ?? '' })
  const handleTabChange = () => { }

  const handleAction = (eventKey: string | undefined, rowData: any) => {
    switch (eventKey) {
      case '2': {
        setSelectedEmail(rowData)
        setIsEditMode(true)
        setAddEmailModal(true)
        break
      }
      default:
        break
    }
  }
  const COLUMNS = [
    { key: 'emailId', label: 'EmailId' },
    { key: 'username', label: 'Username' },
    { key: 'appPassword', label: 'App Password' },
    { key: 'smtpServer', label: 'SMTP Server' },
    { key: 'port', label: 'Port' }
  ]

  const options = [
    {
      label: 'All',
      value: 'All',
      onClick: () => handleTabChange()
    }
  ]

  const handleClose = () => {
    setAddEmailModal(false)
    setIsEditMode(false)
    setSelectedEmail(null)
  }

  const breadcrumbItems: BreadcrumbItemType[] = [
    {
      label: 'Client',
      path: '/client',
      isActive: false
    },
    {
      label: 'Email',
      path: '/client/email',
      isActive: true
    }
  ]

  return (
    <div className="list">
      <BreadcrumHeader items={breadcrumbItems} />
      <Toolbar
        options={options}
        onButtonClick={() => {
          setSelectedEmail(null)
          setIsEditMode(false)
          setAddEmailModal(true)
        }}
        buttonName="Add Email"
      />
      <div className="list__main-container">
        <Table
          data={EmailData ? [EmailData] : []}
          loading={isLoading}
          paginated
          pageSizeOptions={[10, 20, 30]}
          defaultPageSize={10}
        >
          {COLUMNS.map((column, index) => {
            const { key, label } = column
            return (
              <Column
                flexGrow={1}
                key={key}
                align={index === 0 ? 'left' : 'center'}
                sortable
              >
                <HeaderCell>{label}</HeaderCell>
                <Cell dataKey={key} tooltip />
              </Column>
            )
          })}

          <Column flexGrow={1} align="center">
            <HeaderCell>Created At</HeaderCell>
            <DateTimeCell dataKey="createdAt" format="dd/MMM/yy, h:mm a" />
          </Column>

          <Column align="center" key="action" sortable>
            <HeaderCell>Action</HeaderCell>

            <ActionCell
              style={{ paddingLeft: '22%' }}
              tooltip
              dataKey="action"
              onAction={handleAction}
              actionOptions={['Edit']}
            />
          </Column>
        </Table>
      </div>

      <CreateEditEmail
        open={addEmailModal}
        onClose={handleClose}
        isEditMode={isEditMode}
        email={selectedEmail as any}
        clientId={id as any}
      />
    </div>
  )
}
export default ClientEmailList
